import React, { Component } from "react";
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import SpinnerModal from "@components/SpinnerModal";
import { useDialog } from 'react-st-modal';
import styles from './rolepermissionsdialog.module.css';
import SupportAlert from '@components/SupportAlert';
import { FormControl, FormControlLabel, Grid, Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Tooltip, Paper, Checkbox, Switch } from '@mui/material';

class RolePermissionsDialog extends Component {
    state = {
        loading: false,

        systemPermissions: [],
        rolePermissions: [],

        roleName: '',
        roleDescription: '',
        roleActive: false,

        validRoleName: true,
        validRoleDescription: true,
        validRoleActive: true,

        selectedRole: null,
        roleActions: [],
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({ selectedRole: this.props.role });
        this.setState({ roleActive: this.props.role.active });
        this.setState({ roleName: this.props.role.name });
        this.setState({ roleDescription: this.props.role.description });

        let rolesActions = this.props.systemRoles.sort((a, b) => a.action > b.action ? 1 : -1).map(systemRole => {
            return { value: systemRole.action, label: systemRole.action };
        });
        this.setState({ roleActions: rolesActions });

        await (async () => {
            try {
                const systemRolePermissions = await RolePermissionManagementService.getRdiSystemRolePermissionsByRoleId(this.props.role.id);
                this.setState({ rolePermissions: JSON.parse(JSON.stringify(systemRolePermissions)) });
                return systemRolePermissions;
            } catch (ex) {
                console.log('Network error loading system role-permissions');
            }
        })([]);

        this.reloadSystemPermissions();

        this.setState({ loading: false });
    }

    async reloadSystemPermissions() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemPermissionsAll = await RolePermissionManagementService.getRdiSystemPermissions();
                this.setState({ systemPermissions: JSON.parse(JSON.stringify(systemPermissionsAll)) });
                return systemPermissionsAll;
            } catch (ex) {
                console.log('Network error loading system permissions');
            }
        })([]);

        this.setState({ loading: false });
    }

    handlePermissionCheckboxClick(evt, systemPermission) {
        if (evt.target.checked) {
            if (!this.state.rolePermissions.some(rolePermission => rolePermission.id === systemPermission.id)) {
                const newRolePermission = {
                    id: {
                        roleId: this.props.role.id,
                        permissionId: systemPermission.id
                    },
                    role: this.props.role,
                    permission: systemPermission,
                    grantType: 'ALLOW'
                };

                (async () => {
                    try {
                        const rolePermissionEnvelope = [{
                            actionById: this.props.surveysUserId,
                            roleId: this.props.role.id,
                            permissionId: systemPermission.id,
                            grantType: 'ALLOW'
                        }]
                        await RolePermissionManagementService.saveRolePermission(rolePermissionEnvelope);
                        this.setState({ rolePermissions: [...this.state.rolePermissions, newRolePermission] });
                    } catch (ex) {
                        console.log('Error adding permission to role: ' + ex);
                    }
                })([]);
            }
        } else {
            // Remove the permission from the role
            if (this.state.rolePermissions.some(rolePermission => rolePermission.id.permissionId === systemPermission.id)) {
                const rolePermissionToRemove = this.state.rolePermissions.filter(rolePermission => rolePermission.id.permissionId === systemPermission.id)[0];

                (async () => {
                    try {
                        await RolePermissionManagementService.removePermissionFromRole(rolePermissionToRemove.id.roleId, rolePermissionToRemove.id.permissionId, this.props.surveysUserId);
                        this.setState({ rolePermissions: [...this.state.rolePermissions.filter(rolePermission => rolePermission.id.permissionId !== systemPermission.id)] });
                    } catch (ex) {
                        console.log('Error removing permission from role: ' + ex);
                    }
                })([]);

            }
        }
    }

    async handleFlipRolePermissionGrantType(evt, permissionId) {

        if (this.state.rolePermissions.some(rolePermission => rolePermission.id.permissionId === permissionId)) {
            const updateRolePermission = this.state.rolePermissions.find(rolePermission => rolePermission.id.permissionId === permissionId);
            updateRolePermission.grantType = (updateRolePermission.grantType === 'ALLOW' ? 'DENY' : 'ALLOW');

            (async () => {
                try {
                    const rolePermissionEnvelope = [{
                        actionById: this.props.surveysUserId,
                        roleId: updateRolePermission.id.roleId,
                        permissionId: updateRolePermission.id.permissionId,
                        grantType: updateRolePermission.grantType
                    }]
                    await RolePermissionManagementService.saveRolePermission(rolePermissionEnvelope);
                    this.setState({ rolePermissions: [...this.state.rolePermissions.filter(rolePermission => rolePermission.id.permissionId !== permissionId), updateRolePermission] });
                } catch (ex) {
                    console.log('Error updating role-permission: ' + ex);
                }
            })([]);
        }

    }

    getData() {

        let data = {
            actionById: this.props.surveysUserId,
            rdiRole: {
                id: this.props.role.id,
                name: this.state.roleName,
                description: this.state.roleDescription,
                active: this.state.roleActive
            }
        };

        return data;

    }

    dialogBody() {

        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Permissions : " + this.props.role.name}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="column" justify-content="space-between" wrap="nowrap">
                        {<div className={styles.featuredItem}>
                            <TableContainer component={Paper} elevation={0}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={styles.table_header_cell}>
                                                <text className={styles.featuredTitleHeader}>{
                                                    'GRANTED'
                                                }</text>
                                            </TableCell>
                                            <TableCell className={styles.table_header_cell}>
                                                <text className={styles.featuredTitleHeader}>{
                                                    'PERMISSION NAME'
                                                }</text>
                                            </TableCell>
                                            <TableCell className={styles.table_header_cell}>
                                                <text className={styles.featuredTitleHeader}>{'GRANT TYPE'}</text>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.systemPermissions.sort((a, b) => a.id > b.id ? 1 : -1).map(systemPermission => {
                                            return (
                                                <Tooltip
                                                    key={systemPermission.name}
                                                    title={systemPermission.description}
                                                    followCursor
                                                    placement="top-start"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                bgcolor: '#0078D4',
                                                                color: 'white',
                                                                fontSize: '12px',
                                                                padding: '10px',
                                                                borderRadius: '5px',
                                                                maxWidth: '100%',
                                                                '& .MuiTooltip-arrow': {
                                                                    color: '#0078D4'
                                                                }
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <TableRow
                                                        key={systemPermission.name}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="td">
                                                            <Checkbox
                                                                checked={this.state.rolePermissions.some(rolePermission => rolePermission.permission?.id === systemPermission.id)}
                                                                size="small"
                                                                onChange={(event) => this.handlePermissionCheckboxClick(event, systemPermission)}
                                                                color="primary"
                                                                sx={{
                                                                    '&.MuiCheckbox-root': {
                                                                        padding: '4px',
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        width: '20px',
                                                                        height: '20px'
                                                                    }
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell component="td">
                                                            <text className={styles.featuredText}>
                                                                {systemPermission?.name?.toUpperCase()}
                                                            </text>
                                                        </TableCell>
                                                        <TableCell component="td">
                                                            <FormControl>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Switch
                                                                            disabled={!this.state.rolePermissions.some(rolePermission => rolePermission.permission?.id === systemPermission.id)}
                                                                            name='allow_role_permission'
                                                                            size='small'
                                                                            color='primary'
                                                                            checked={(this.state.rolePermissions.filter(rolePermission => (rolePermission.permission?.id === systemPermission?.id))[0]?.grantType?.toUpperCase() === 'ALLOW')}
                                                                            onChange={(evt) => {
                                                                                this.handleFlipRolePermissionGrantType(evt, systemPermission.id)
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={(this.state.rolePermissions.filter(rolePermission => rolePermission.permission?.id === systemPermission?.id)[0]?.grantType?.toUpperCase() === 'ALLOW') ? "ALLOW" : "DENY"}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                    </TableRow>
                                                </Tooltip>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>}
                    </Grid>
                </p>
            </div>
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                onClick={(evt) => this.props.nextButton.onClick(evt, this.getData())}
                validDetails={(this.state.validRoleName === true) &&
                    (this.state.validRoleDescription === true) &&
                    (this.state.validRoleActive === true)}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default RolePermissionsDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            if (!props.validDetails) {
                                SupportAlert.displayAlert('Updating role failed', 'Please review supplied information carefully.');
                            } else {
                                props.onClick(evt);
                                dialog.close(true);
                            }
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

